import {ReactPIXISystemPopup} from '@gongxigames/framework/slot/types/SystemPopup';
import {MessageText} from '@gongxigames/framework/slot/types/Message';
import {CanBeSignal} from '@gongxigames/framework/core/fragments/BuilderY';
import {SafeZone} from '@gongxigames/framework/core/fragments/display/SafeZone/SafeZone';

export type MessagePopupButton = {
    title: MessageText;
    action: Function;
};

export type MessagePopupData = {
    title: MessageText;
    message?: MessageText;
    buttons?: MessagePopupButton[];
    withBorders?: boolean;
    safeZoneContainer?: CanBeSignal<SafeZone>;
    closeButton?: {
        visible: boolean;
        onClick: () => void;
    };
};

export type MessagePopup = ReactPIXISystemPopup<MessagePopupData>;
